<div class="c-pagination-footer">
  <label class="c-pagination-footer__label">
    Mostrando {{ getRangeStart() }} a {{ getRangeEnd() }} de
    {{ pagination().elements }} datos
    <!--     {{ pagination().offset + pagination().elements -1 }} de {{ pagination().elements }} datos -->
  </label>
  <div class="d-flex align-items-center">
    @if (verDatos()) {
      <label class="c-pagination()-footer__label me-1">
        {{ pagination().currentPage }} de {{ pagination().totalPages }} páginas
      </label>
    }
    <ngb-pagination
      [collectionSize]="pagination().elements"
      [page]="filtros().start"
      [pageSize]="filtros().limit"
      [maxSize]="2"
      [rotate]="true"
      [boundaryLinks]="false"
      (pageChange)="pageOnChange($event)"
      [disabled]="disabled()"
    >
    </ngb-pagination>
  </div>
</div>
